import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';

interface FAQChild {
  text: string;
}

interface FAQParagraph {
  children: FAQChild[];
}

interface FAQ {
  heading: string;
  content: FAQParagraph[];
}

interface SectionsFaQs {
  __typename?: string;
  faqs?: FAQ[];
  padding: {
    mobile_top_padding: any;
    mobile_bottom_padding: any;
    desktop_top_padding: any;
    desktop_bottom_padding: any;
  };
}

interface FAQsSectionProps {
  data: SectionsFaQs;
}
type BlocksRendererProps = React.ComponentProps<typeof BlocksRenderer>;

const ComponentSectionsFaQs: React.FC<FAQsSectionProps> = ({ data }: { data: any }) => {
  const [activeIndex, setActiveIndex] = useState<number | null>(0);
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const handleToggle = (index: number) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };
  const sectionsFaQs = data;
  const [top, setTop] = useState('');
  const [bottom, setBottom] = useState('');

  useEffect(() => {
    const updatePadding = () => {
      const isMobile = window.innerWidth <= 768;
      if (isMobile) {
        setTop(data.padding?.mobile_top_padding ?? '');
        setBottom(data.padding?.mobile_bottom_padding ?? '');
      } else {
        setTop(data.padding?.desktop_top_padding ?? '');
        setBottom(data.padding?.desktop_bottom_padding ?? '');
      }
    };

    updatePadding(); // Run on mount

    window.addEventListener('resize', updatePadding); // Listen on resize
    return () => window.removeEventListener('resize', updatePadding); // Clean up
  }, [data]);
  return (
    <section
      className="md:border-t border-[#9e703e66] md:pt-5 sidebarNav-Id"
      style={{
        paddingTop: `${top}rem`,
        paddingBottom: `${bottom}rem`,
      }}
      id={sectionsFaQs?.__typename}
    >
      {/* desktop faq  */}
      <div className="md:grid grid-cols-12 gap-3 items-start hidden">
        {/* Left Column - Headings */}
        <div className="col-span-6 space-y-0">
          {sectionsFaQs?.faqs?.map((faq: FAQ, index: number) => {
            const isActive = activeIndex === index;
            return (
              <h3
                key={index}
                onClick={() => handleToggle(index)}
                className={`cursor-pointer text-xl font-light transition-colors hover:text-[#9E703E] duration-200 ${
                  isActive ? 'text-[#9E703E]' : 'text-[#9E703E]/40'
                }`}
              >
                {faq.heading}
              </h3>
            );
          })}
        </div>

        {/* Right Column - Animated Answer */}
        <div className="col-span-6 right-content">
          <AnimatePresence mode="wait">
            {activeIndex !== null && sectionsFaQs?.faqs?.[activeIndex]?.content && (
              <motion.div
                key={activeIndex}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 10 }}
                transition={{ duration: 0.3 }}
                className="text-base font-light text-[#9E703E] indent-10 leading-relaxed"
              >
                {sectionsFaQs.faqs[activeIndex].content.map(
                  (para: FAQParagraph, paraIdx: number) => (
                    <p key={paraIdx}>
                      {para.children.map((child: FAQChild, childIdx: number) => (
                        <span key={childIdx}>{child.text}</span>
                      ))}
                    </p>
                  )
                )}
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>

      {/* mobile faq  */}

      <div className="flex flex-col md:hidden">
        <h3 className="text-[22px] font-light leading-none mb-5 text-[#9E703E]">FAQS</h3>

        <div className="flex flex-col mobile-faq w-full">
          {sectionsFaQs?.faqs?.map((faq: FAQ, index: number) => (
            <div className="faq-item w-full border-t border-b border-[#9E703E]/40" key={index}>
              <button
                type="button"
                onClick={() => toggleFAQ(index)}
                className="flex items-center justify-between w-full text-start gap-4 py-3 font-medium text-base leading-none"
              >
                {faq.heading} aaa
                <span className="text-[28px]">{openIndex === index ? '−' : '+'}</span>
              </button>

              <AnimatePresence initial={false}>
                {openIndex === index && (
                  <motion.div
                    key="content"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <div className="faq-content py-2 font-light text-base blocksRenderer">
                      {/* {faq.content?.map((paragraph, pIndex) => (
                        <p key={pIndex} className="mb-2">
                          {paragraph.children?.map((child, cIndex) => (
                            <span key={cIndex}>{child.text}</span>
                          ))}
                        </p>
                      ))} */}
                      <BlocksRenderer content={faq.content as BlocksRendererProps['content']} />
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ComponentSectionsFaQs;
